import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearKickedNotice } from '../redux/gameSlice';
import './KickedNotice.css';

// Global popup shown when the server auto-removes the player from a table after their
// 5-minute sit-out timer expires (PLAYER_KICKED). Rendered at the app level so it
// survives the table being torn down / the return to the lobby.
const KickedNotice = () => {
    const dispatch = useDispatch();
    const kickedNotice = useSelector((state) => state.games.kickedNotice);

    if (!kickedNotice) return null;

    return (
        <div className="kicked-notice-overlay" onClick={() => dispatch(clearKickedNotice())}>
            <div className="kicked-notice-box" onClick={(e) => e.stopPropagation()}>
                <span className="kicked-notice-title">You've been kicked due to inactivity</span>
                <span className="kicked-notice-subtext">
                    You were removed from the table for sitting out too long.
                </span>
                <button className="kicked-notice-btn" onClick={() => dispatch(clearKickedNotice())}>
                    OK
                </button>
            </div>
        </div>
    );
};

export default KickedNotice;
